import { render, staticRenderFns } from "./Step5.vue?vue&type=template&id=13024278&scoped=true&lang=pug&"
import script from "./Step5.vue?vue&type=script&lang=js&"
export * from "./Step5.vue?vue&type=script&lang=js&"
import style0 from "./Step5.vue?vue&type=style&index=0&id=13024278&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../Volumes/bsdcDoc/yimanDoc/htdocs/tocin_projects/tocin_web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13024278",
  null
  
)

export default component.exports